import useLocalStorage from "@hooks/useLocalStorage";
import useCookieClient from "@hooks/useCookieClient";
import { useEffect, useState } from "react";
export function _checkABFlag(flag, getCookieClient, getLocalStorage) {
  if (__IS_CSR__ && window.location.href.includes(flag)) {
    var urlParams = new URLSearchParams(window.location.search);
    var myParam = urlParams.get(flag);
    return myParam !== "false";
  }
  if (__IS_CSR__ && getLocalStorage(flag)) {
    return Boolean(Number(getLocalStorage(flag))) || getLocalStorage(flag) === "true";
  }
  if (__IS_CSR__ && getCookieClient(flag)) {
    return Boolean(Number(getCookieClient(flag)));
  }
  if (__IS_CSR__ && document.body.classList.contains(flag)) {
    return true;
  }
  return undefined;
}
var useCheckABFlag = function useCheckABFlag(flag) {
  var _useLocalStorage = useLocalStorage(),
    getLocalStorage = _useLocalStorage.getLocalStorage;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  var _useState = useState(function () {
      return _checkABFlag(flag, getCookieClient, getLocalStorage);
    }),
    flagValue = _useState[0],
    setFlagValue = _useState[1];
  useEffect(function () {
    var interval = setInterval(function () {
      var newValue = _checkABFlag(flag, getCookieClient, getLocalStorage);
      setFlagValue(function (prevValue) {
        return prevValue !== newValue ? newValue : prevValue;
      });
    }, 400);
    return function () {
      return clearInterval(interval);
    };
  }, [flag, getCookieClient, getLocalStorage]);
  return flagValue;
};
export default useCheckABFlag;